<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>Invoices</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Reports</a>
        </li>
        <li class="breadcrumb-item active">Invoices</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box box-solid bg-black">
            <div class="box-header with-border">
              <h3 class="box-title">Confirmed Invoices</h3>

              <div class="box-tools pull-right">
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="remove"
                  data-toggle="tooltip"
                  title="Remove"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-bordered no-margin">
                  <thead class="bg-dark">
                    <tr>
                      <th class="text-white text-left">ID</th>
                      <th class="text-white text-left">Hash (TXID)</th>
                      <th class="text-white text-left">Price</th>
                      <th class="text-white text-left">Pack</th>
                      <th class="text-white text-center">Status</th>
                      <th class="text-white text-right">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in tableData" :key="invoice.id">
                      <template v-if="invoice.invoice_status === 'paid'">
                        <td class="text-left">{{ invoice.id }}</td>
                        <td class="text-left">
                          <a href="#" class="text-yellow hover-warning">{{
                            invoice.txid
                          }}</a>
                        </td>
                        <td class="text-left">
                          {{ invoice.price }} {{ invoice.currency.name }}
                        </td>

                        <td class="text-left">{{ invoice.plan.name }}</td>
                        <td class="text-center">
                          <span
                            class="label"
                            :class="
                              (invoice.invoice_status === 'pending' &&
                                'label-warning') ||
                              (invoice.invoice_status === 'paid' &&
                                'label-success') ||
                              (invoice.invoice_status === 'cancelled' &&
                                'label-danger')
                            "
                          >
                            {{
                              (invoice.invoice_status === "pending" &&
                                "Unconfirmed") ||
                              (invoice.invoice_status === "paid" &&
                                "Confirmed") ||
                              (invoice.invoice_status === "cancelled" &&
                                "Canceled")
                            }}
                          </span>
                        </td>
                        <td class="text-right">
                          <time>{{
                            invoice.payment_confirmed_at
                              | formatDate("MMMM Do YYYY hh:mm A")
                          }}</time>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="box box-solid bg-black">
            <div class="box-header with-border">
              <h3 class="box-title">Unconfirmed Invoices</h3>

              <div class="box-tools pull-right">
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="remove"
                  data-toggle="tooltip"
                  title="Remove"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-bordered no-margin">
                  <thead class="bg-dark">
                    <tr>
                      <th class="text-white text-left">ID</th>
                      <th class="text-white text-left">Wallet</th>
                      <th class="text-white text-left">Price</th>
                      <th class="text-white text-left">Pack</th>
                      <th class="text-white text-center">Status</th>
                      <th class="text-white text-right">Details</th>
                      <th class="text-white text-right">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in tableData" :key="invoice.id">
                      <template v-if="invoice.invoice_status === 'pending'">
                        <td class="text-left">{{ invoice.id }}</td>
                        <td class="text-left">
                          <a href="#" class="text-yellow hover-warning">{{
                            invoice.wallet
                          }}</a>
                        </td>
                        <td class="text-left">
                          {{ invoice.price }} {{ invoice.currency.name }}
                        </td>

                        <td class="text-left">{{ invoice.plan.name }}</td>
                        <td class="text-center">
                          <span
                            class="label"
                            :class="
                              (invoice.invoice_status === 'pending' &&
                                'label-warning') ||
                              (invoice.invoice_status === 'paid' &&
                                'label-success') ||
                              (invoice.invoice_status === 'cancelled' &&
                                'label-danger')
                            "
                          >
                            {{
                              (invoice.invoice_status === "pending" &&
                                "Unconfirmed") ||
                              (invoice.invoice_status === "paid" &&
                                "Confirmed") ||
                              (invoice.invoice_status === "cancelled" &&
                                "Canceled")
                            }}
                          </span>
                        </td>
                        <td class="text-right">
                          <router-link
                            :to="'/invoices/' + invoice.id"
                            class="text-yellow hover-warning"
                            >Details</router-link
                          >
                        </td>
                        <td class="text-right">
                          <time>
                            {{
                              invoice.created_at
                                | formatDate("MMMM Do YYYY hh:mm A")
                            }}
                          </time>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VueQrcode from "@chenfengyuan/vue-qrcode";

import { formatDate, formatDollar } from "@/filters";

Vue.use(VueClipboard);
Vue.component(VueQrcode.name, VueQrcode);

export default {
  data() {
    return {
      type: "",
      loading: false,
      tableData: [],
      modal: false,
      invoice: {},
    };
  },
  filters: { formatDate, formatDollar },
  created() {
    this.getData();
  },
  methods: {
    onCopy() {
      this.$notify({
        type: "danger",
        title: "Copied !",
      });
    },

    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/invoices", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
        })
        .then((response) => {
          this.tableData = response.data;
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },

    setInvoice(object) {
      this.modal = true;
      this.invoice = object;
    },

    close() {
      this.modal = false;
    },
  },
};
</script>
